import { useEffect, useState } from "react";
import { useMap } from "react-leaflet";
import { TileEvent, tileLayer } from "leaflet";
import { getBlobByKey, downloadTile, saveTile } from "leaflet.offline";
import { TILES_URL } from "@/utils/constants/leaflet";
import { logger } from "@/utils/functions/logger";

interface TileInfo {
  key: string;
  url: string;
  x: number;
  y: number;
  z: number;
  urlTemplate: string;
  createdAt: number;
}

const useOfflineTiles = () => {
  const leafletMap = useMap();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const brtLayer = tileLayer(TILES_URL, { minZoom: 6, maxZoom: 21, maxNativeZoom: 19 });

    brtLayer.addTo(leafletMap);

    brtLayer.on("tileloadstart", (event: TileEvent) => {
      const { tile } = event;
      const url = tile.src;
      // reset tile.src, to not start download yet
      tile.src = "";
      getBlobByKey(url).then((blob: Blob | null) => {
        if (blob && leafletMap.getZoom() < 20) {
          tile.src = URL.createObjectURL(blob);
          logger.debug(`Loaded ${url} from idb`);
          return;
        }
        tile.src = url;
        // create helper function for it?
        const { x, y, z } = event.coords;
        const { _url: urlTemplate } = event.target;
        const tileInfo: TileInfo = {
          key: url,
          url,
          x,
          y,
          z: leafletMap.getZoom() >= 20 ? 19 : z,
          urlTemplate,
          createdAt: Date.now(),
        };

        if (navigator.onLine)
          downloadTile(url)
            .then((dl: Blob) => {
              saveTile(tileInfo, dl);
            })
            .then(() => logger.debug(`Saved ${url} in idb`));
      });
    });

    brtLayer.on("loading", () => {
      setLoading(true);
    });

    brtLayer.on("load", () => {
      setLoading(false);
    });

    return () => {
      leafletMap.off("tileloadstart");
      brtLayer.off("loading");
      brtLayer.off("load");
    };
  }, [leafletMap]);

  return loading;
};

export default useOfflineTiles;
